import { render, staticRenderFns } from "./PreviewTemplateUserProfile.vue?vue&type=template&id=95bb6332&scoped=true"
import script from "./PreviewTemplateUserProfile.vue?vue&type=script&lang=js"
export * from "./PreviewTemplateUserProfile.vue?vue&type=script&lang=js"
import style0 from "./PreviewTemplateUserProfile.vue?vue&type=style&index=0&id=95bb6332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bb6332",
  null
  
)

export default component.exports